// Setup select field
export function selectField() {
  const body    = document.body;
  const selects = document.querySelectorAll('.wpcf7-form select');

  selects.forEach(function(select) {
    var firstOption = select.querySelector('option');
    if (firstOption) firstOption.disabled = true;
  });
}